import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import TokenSetWrapper from "./TokenSetWrapper";
import { useSelector } from "react-redux";
import ForoFourPage from "ForoFourPage";
import "./App.css";
import MobileSidebar from "components/sidebar/MobileSidebar";
import DefaultLayout from "layouts/Default";
import PoweredBy from "components/poweredBy/PoweredBy";
import PrivacyPolicy from "components/privacyPolicy/PrivacyPolicy";

const App = () => {
  //login user state
  const loginUser = useSelector((state) => state?.authReducer?.data);
  const location = useLocation();
  const isPrivacyPolicy = location.pathname === "/privacy-policy";

  return (
    <TokenSetWrapper>
      {!isPrivacyPolicy && <PoweredBy />}
      {!isPrivacyPolicy && <MobileSidebar />}
      <Routes>
        {/* Default route based on authentication status */}
        <Route
          path="/"
          element={
            loginUser?.token ? (
              <Navigate to="/admin" />
            ) : (
              <Navigate to="/auth" />
            )
          }
        />

        {/* Admin route for authenticated users */}
        <Route
          path="/admin/*"
          element={loginUser?.token ? <AdminLayout /> : <Navigate to="/auth" />}
        />


        {/* Auth route for unauthenticated users */}
        <Route path="/auth/*" element={<AuthLayout />} />
        {/* route for default layout and render page*/}
        <Route path="/default/machine-management/bulk-upload-guide" element={<DefaultLayout />} />

        {/* Public route for Privacy Policy */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Catch-all route to handle 404 */}
        <Route path="*" element={<ForoFourPage />} />
      </Routes>
    </TokenSetWrapper>
  );
};

export default App;
